import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';


const SUBGRAPH_API_KEY = '702ab2e807869201b9092c8f148e3f9e';
const AXT_SUBGRAPH_URL = 'https://gateway.thegraph.com/api/subgraphs/id/GMQAREQN5xfopmMJFSMwCXnfh2DbcBKUn2oqKUv4VCDX';
const BLOCK_SUBGRAPH_API_KEY = 'a3f14d5b725c52a6b8b3c11931007a23';
const INDEX_NODE_API_KEY = '702ab2e807869201b9092c8f148e3f9e';


const logErrors = (operation, forward) => {
  console.log(`query start ${operation.operationName || 'अनाम क्वेरी'}`, operation.variables);
  return forward(operation).map(response => {
    if (response.errors) {
      console.log(`GraphQL issue (${operation.operationName}):`, response.errors);
    }
    if (response.data === null && !response.errors) {
      console.log(`network issue (${operation.operationName}): डेटा नहीं मिला`);
    }
    console.log(`qery result (${operation.operationName}):`, response.data);
    return response;
  });
};

export const client = new ApolloClient({
  link: new HttpLink({
    uri: AXT_SUBGRAPH_URL,
    headers: {
      Authorization: `Bearer ${SUBGRAPH_API_KEY}`,
    },
    fetch: (uri, options) => {
      console.log(`qery sending (client): ${uri}`, options.body);
      return fetch(uri, options).catch(err => {
        console.log('नेटवर्क त्रुटि (client):', err);
        throw err;
      });
    },
  }).concat(logErrors),
  cache: new InMemoryCache(),
  shouldBatch: true,
});

export const healthClient = new ApolloClient({
  link: new HttpLink({
    uri: 'https://api.thegraph.com/index-node/graphql',
    headers: {
      Authorization: `Bearer ${INDEX_NODE_API_KEY}`,
    },
    fetch: (uri, options) => {
      console.log(`qery sending(healthClient): ${uri}`, options.body);
      return fetch(uri, options).catch(err => {
        console.log('नेटवर्क त्रुटि (healthClient):', err);
        throw err;
      });
    },
  }).concat(logErrors),
  cache: new InMemoryCache(),
  shouldBatch: true,
});

export const v1Client = new ApolloClient({
  link: new HttpLink({
    uri: 'https://api.thegraph.com/subgraphs/name/ianlapham/uniswap',
    fetch: (uri, options) => {
      console.log(`qery sending(v1Client): ${uri}`, options.body);
      return fetch(uri, options).catch(err => {
        console.log('नेटवर्क त्रुटि (v1Client):', err);
        throw err;
      });
    },
  }).concat(logErrors),
  cache: new InMemoryCache(),
  shouldBatch: true,
});

export const stakingClient = new ApolloClient({
  link: new HttpLink({
    uri: 'https://api.thegraph.com/subgraphs/name/way2rach/talisman',
    fetch: (uri, options) => {
      console.log(`qery sending (stakingClient): ${uri}`, options.body);
      return fetch(uri, options).catch(err => {
        console.log('नेटवर्क त्रुटि (stakingClient):', err);
        throw err;
      });
    },
  }).concat(logErrors),
  cache: new InMemoryCache(),
  shouldBatch: true,
});

export const blockClient = new ApolloClient({
  link: new HttpLink({
    uri: `https://gateway.thegraph.com/api/${BLOCK_SUBGRAPH_API_KEY}/subgraphs/id/9dSPXfKXaqYpoGAPXx96LyDF1VYR8PiT6HA7HRKEGRdS`,
    headers: {
      Authorization: `Bearer ${BLOCK_SUBGRAPH_API_KEY}`,
    },
    fetch: (uri, options) => {
      console.log(`qery sending (blockClient): ${uri}`, options.body);
      return fetch(uri, options).catch(err => {
        console.log('नेटवर्क त्रुटि (blockClient):', err);
        throw err;
      });
    },
  }).concat(logErrors),
  cache: new InMemoryCache(),
  shouldBatch: true,
});